import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { ChevronRightIcon } from '@heroicons/react/20/solid'


const homeFaqs = [
   { question: "What is Shecluded?", answer: "Shecluded is a financial growth company focused on empowering women with access to credit, business support, financial education, wealth advisory, community, and pension plans. Our mission is to help women grow sustainable businesses and achieve personal financial freedom."},
   { question: "How do I join the Shecluded community?", answer: "You can join the community by visiting https://shecluded.com/community and following the instructions to sign up."},
   { question: "What types of financial services does Shecluded offer?", answer: "Shecluded offers a range of financial services, including growth loans tailored to women's needs, financial literacy resources, insurance packages for better healthcare access, and business support services like branding and marketing advisory."},
   { question: "What if I don't need a loan?", answer: "Explore our workshops, savings products, health insurance (HMO), wealth advisory, and business advisory services."},
   { question: "What other funding options are available?", answer: "We run seasonal business pitch competitions and enterprise challenges where winners receive grants."},
]


export default function Faq() {
    return (
        <section className='pt-6 mb-0 pb-0'>
            <h1 className="lg-max-w-4xl md-max-w-xl text-3xl lg:text-5xl  text-center text-text-color  tracking-normal font-semibold">FAQ </h1>
            <div className="w-full pt-6 lg:pt-10 px-6 lg:px-14">
                <div className="w-full">
                    {homeFaqs.map((faq, index) => (
                    <Disclosure as="div" className="rounded-2xl lg:rounded-full bg-light-grey-5 py-6 px-6 lg:px-14 mb-6">
                        <DisclosureButton className="group flex w-full items-center justify-between">
                            <span className="text-base lg:text-lg font-semibold text-text-color text-left group-data-[hover]:text-primary">
                                   {faq.question}
                            </span>
                            <ChevronRightIcon className="size-5 lg:size-7 fill-black group-data-[hover]:fill-primary group-data-[open]:rotate-180" />
                        </DisclosureButton>
                        <DisclosurePanel
                            transition
                            className="mt-3 text-sm lg:text-base text-dark-grey-1 lg:pr-20 transition duration-200 ease-out">
                           {faq.answer}
                        </DisclosurePanel>
                    </Disclosure>
                   ))}
                  
                  
                </div>
            </div>
            <hr className='my-10 border-1 border-light-grey-5'></hr>
        </section>
        
    )
}